import React, { FC } from 'react';
import { Employer } from '../types';
import { Stack, Typography } from '@mui/material';
import EmployerFunction from './EmployerFunction';
import dayjs from 'dayjs';
import { PLANS } from '@utils/pricing';

type AccountDetailedInfoProps = {
  account: Employer;
  paidCount?: { object: number };
};

const AccountDetailedInfo: FC<AccountDetailedInfoProps> = ({
  account,
  paidCount,
}) => {
  return (
    <Stack spacing={0} marginTop={2}>
      <Typography
        sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 2 }}
      >
        Account Info
      </Typography>
      <EmployerFunction
        title="Last Login"
        value={
          account.last_login
            ? dayjs(account.last_login).format('MM/DD/YY')
            : '-'
        }
        bg={true}
      />
      <EmployerFunction
        title="Service Plan"
        value={
          account.company && paidCount?.object
            ? account.company.plan === 0
              ? PLANS.EXPIRED.NAME
              : account.company.plan === 1
                ? PLANS.SMARTER.NAME
                : account.company.plan === 2
                  ? PLANS.PRO.NAME
                  : account.company.plan === 4
                    ? PLANS.STARTER.NAME
                    : account.company.plan === 3
                      ? 'Service Plus Network'
                      : account.company.plan === 999
                        ? PLANS.TRIAL.NAME
                        : '-'
            : account.enterprise
              ? account.enterprise.plan === 0
                ? PLANS.EXPIRED.NAME
                : account.enterprise.plan === 1
                  ? 'Tier 1'
                  : account.enterprise.plan === 2
                    ? 'Tier 2'
                    : account.enterprise.plan === 3
                      ? 'Service Plus Network'
                      : account.enterprise.plan === 999
                        ? PLANS.TRIAL.NAME
                        : '-'
              : '-'
        }
        bg={false}
      />
      <EmployerFunction
        title="User Type"
        value={
          account.company && account.master_account
            ? 'Admin'
            : account.enterprise && account.master_account
              ? 'Ent Admin'
              : 'Sub User'
        }
        bg={true}
      />
      {account.company && (
        <EmployerFunction
          title="Enterprise"
          value={account.company.enterprise_company ? 'Yes' : 'No'}
          bg={false}
        />
      )}
      {account.company && (
        <EmployerFunction
          title="Billing on"
          value={
            account.company && account.company.is_company_paid
              ? 'Employer'
              : 'Enterprise'
          }
          bg={true}
        />
      )}
    </Stack>
  );
};

export default AccountDetailedInfo;
